import { render, staticRenderFns } from "./flowTabs.vue?vue&type=template&id=2231eb00&scoped=true&"
import script from "./flowTabs.vue?vue&type=script&lang=js&"
export * from "./flowTabs.vue?vue&type=script&lang=js&"
import style0 from "./flowTabs.vue?vue&type=style&index=0&id=2231eb00&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2231eb00",
  null
  
)

export default component.exports